var _ellipse, _rect, _path, _path2, _rect2, _path3, _rect3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreProduct = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.97,
  cy: 4.713,
  rx: 4.701,
  ry: 4.713,
  fill: "#FFC700"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6.269,
  height: 6.283,
  rx: 1.567,
  transform: "rotate(-15.036 17.36 -3.749) skewX(-.073)",
  fill: "#F74F2A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.053 2.155a1.172 1.172 0 0 1 1.588-.403l3.055 1.768c.572.331.76 1.07.415 1.633l-3.452 5.648a1.172 1.172 0 0 1-1.588.404l-3.054-1.768a1.178 1.178 0 0 1-.415-1.634l3.451-5.648Z",
  fill: "#FFA14D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.214 6.676c.619 0 1.117.467 1.117 1.037 0 .57-.506 1.037-1.125 1.037h-.305l-.776 4.361a5.5 5.5 0 0 0-7.16 6.527h-7.71c-1.109 0-2.05-.747-2.21-1.761L1.42 8.75h-.296C.506 8.75 0 8.283 0 7.713c0-.57.506-1.037 1.125-1.037h20.089Z",
  fill: "#63CE05"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.578,
  y: 9.426,
  width: 1.175,
  height: 7.855,
  rx: 0.588,
  fill: "#DFF5BF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.104 10.014a.588.588 0 0 1 1.175 0v2.217a.588.588 0 0 1-1.175 0v-2.217Z",
  fill: "#DFF5BF"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 7.052,
  y: 9.426,
  width: 1.175,
  height: 7.855,
  rx: 0.588,
  fill: "#DFF5BF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.612 20.623a.75.75 0 0 1 1.062-.003l2.279 2.274c.294.293.295.77.003 1.065a.75.75 0 0 1-1.062.003l-2.279-2.274a.755.755 0 0 1-.003-1.065Z",
  fill: "#2D91FF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.341 15.847c1.378 0 2.5 1.122 2.5 2.5 0 1.377-1.122 2.499-2.5 2.499a2.503 2.503 0 0 1-2.5-2.5c0-1.377 1.122-2.499 2.5-2.499Zm0-1.666a4.168 4.168 0 0 0-4.167 4.165 4.168 4.168 0 0 0 8.334 0c0-2.299-1.867-4.165-4.167-4.165Z",
  fill: "#2D91FF"
})));
export default SvgMoreProduct;